import React from "react";
import { ContactUsAPI } from "../../services/apiServices";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
const ContactUs = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      const response = await ContactUsAPI(data);
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
        });
        reset(); // Reset the form on success
      } else {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.warn("Error while submitting form:", err);
    }
  };
  return (
    <div className="mt-10">
      <div className="container mx-auto max-w-4xl">
        <h6 className="text-xl text-[#5D5D5D]">{t("contactus_get_started")}</h6>
        <h2 className="md:text-6xl text-4xl  text-primary-text font-bold mt-5">
          <span className="text-secondary">{t("contactus_title_highlight")}</span> <br />
          {t("contactus_title_sub")}
        </h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-12 gap-6 mt-10">
            <div className="md:col-span-4 col-span-12">
              <input
                type="text"
                placeholder={t("contactus_name_placeholder")}
                className="w-full p-3 border-b border-[#CACACA] focus:border-secondary focus:outline-none"
                {...register("name", { required: t("contactus_name_required") })}
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name.message}</p>
              )}
            </div>

            <div className="md:col-span-4 col-span-12">
              <input
                type="email"
                placeholder={t("contactus_email_placeholder")}
                className="w-full p-3 border-b border-[#CACACA] focus:border-secondary focus:outline-none"
                {...register("email", {
                  required: t("contactus_email_required"),
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: t("contactus_email_invalid"),
                  },
                })}
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email.message}</p>
              )}
            </div>

            <div className="md:col-span-4 col-span-12">
              <input
                type="text"
                placeholder={t("contactus_phone_placeholder")}
                className="w-full p-3 border-b border-[#CACACA] focus:border-secondary focus:outline-none"
                {...register("phone")}
              />
            </div>

            <div className="col-span-12">
              <textarea
                className="w-full p-3 border-b border-[#CACACA] focus:border-secondary focus:outline-none resize-none"
                placeholder={t("contactus_message_placeholder")}
                rows={4}
                {...register("message", { required: t("contactus_message_required") })}
              />
              {errors.message && (
                <p className="text-red-500 text-sm">{errors.message.message}</p>
              )}
            </div>

            <div className="col-span-12">
              <div className="text-right mb-4">
                <button
                  type="submit"
                  className="text-white bg-red-600 text-base font-semibold rounded-[45px] px-4 py-2"
                >
                  {t("contactus_submit")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
